import {
  isInArticleAdUnit,
  isMediumRectangleAdUnit,
  isStandardBannersAdUnit
} from '../../../../../common/js/adUnit';
import { IN_ARTICLE_REVEAL } from '../../../enums/in-article';
import { InArticleRevealVideoStyleStrategy } from './in-article-reveal-video-style-strategy';
import { MediumRectangleVideoStyleStrategy } from './medium-rectangle-video-style-strategy';
import { VideoStyleStrategy } from './video-style-strategy';
import { VideoStore } from '../../../../../common/js/stores/video.store';
import { ConfigStore } from '../../../../../common/js/stores/config.store';
import { StandardBannersVideoStyleStrategy } from './standard-banners-video-style-strategy';

export function getVideoStyleStrategy(
  videoStore: VideoStore,
  configStore: ConfigStore
): VideoStyleStrategy {
  if (isMediumRectangleAdUnit(videoStore.adContext.adUnitType)) {
    return new MediumRectangleVideoStyleStrategy(videoStore, configStore);
  }

  if (
    isInArticleAdUnit(videoStore.adContext.adUnitType) &&
    videoStore.adContext.inArticleType === IN_ARTICLE_REVEAL
  ) {
    return new InArticleRevealVideoStyleStrategy(videoStore, configStore);
  }

  if (isStandardBannersAdUnit(videoStore.adContext.adUnitType)) {
    return new StandardBannersVideoStyleStrategy(videoStore, configStore);
  }

  return new VideoStyleStrategy(videoStore, configStore);
}
